import CustomDropdownComponent from './custom-dropdown-component';

/***
 * A dropdown used in the filter-bar to display the items for filtering a form.
 */
const customDropdown = angular
    .module('FacilityData.Common.CustomDropdown', [])
    .component('customDropdown', CustomDropdownComponent)
    .name;

export default customDropdown;


// WEBPACK FOOTER //
// ./app/common/custom-dropdown/custom-dropdown.js